import service from '../apihttp'
import config from '@/assets/config.json'


/**
 * 
 * @文章 
 * @config.shopHttps.api 
 */

//店铺
export function getshoplist(data) {
    const url = config.shopHttps.api + '/apirebate/systemshop/getshoplist'
    return service.get(url, data)
}
//活动发起提交
export function setshoplist(data) {
    const url = config.shopHttps.api + '/apirebate/system/rebateshop'
    return service.post(url, data)
}
//活动列表
export function getactivelist(data) {
    const url = config.shopHttps.api + '/apirebate/system/rebateshoplist'
    return service.post(url, data)
}
//活动管理的授权 
export function autolist(data) {
    const url = config.shopHttps.api + '/apirebate/system/rebateshopauth'
    return service.post(url, data)
}
//活动管理-下载模板
export function exportexcel(data) {
    const url = config.shopHttps.api + '/apirebate/system/exportexcel'
    return service.post(url, data)
}
//活动管理-批量导入
export function importexcel(data) {
    const url = config.shopHttps.api + '/apirebate/system/importexcel'
    return service.post(url, data)
}
//激活管理-经纬度
export function getgeo(data) {
    const url = config.shopHttps.api + '/apirebate/system/getgeo'
    return service.post(url, data)
}
//激活管理-经纬度提交
export function setgeo(data) {
    const url = config.shopHttps.api + '/apirebate/system/addgeo'
    return service.post(url, data)
}
//激活管理-s授权新增
export function addagent(data) {
    const url = config.shopHttps.api + '/apirebate/system/addagent'
    return service.post(url, data)
}
//运营人id
export function getactiveuser(data) {
    // const url = config.shopHttps.api + '/apiadministrator/goodsclassifys/classifysadminlist'
    const url = config.shopHttps.api + '/apirebate/usercode/classifysadminlist'
    return service.post(url, data)
}
//编辑
export function editrebateshop(data) {
    const url = config.shopHttps.api + '/apirebate/system/editrebateshop'
    return service.post(url, data)
}
//商品订单
export function getshoporder(data) {
    const url = config.shopHttps.api + '/apirebate/systemshop/getshopgoods'
    return service.get(url, data)
}
//添加至活动/apirebate/systemshop/addshopgoods
export function addshopgoods(data) {
    const url = config.shopHttps.api + '/apirebate/systemshop/addshopgoods'
    return service.post(url, data)
}
//消息管理
export function getmessage(data) {
    const url = config.shopHttps.api + '/apirebate/system/getmessage'
    return service.post(url, data)
}
//订单管理
export function orderList(data) {
    const url = config.shopHttps.api + '/apirebate/system/rebateorderlist'
    return service.post(url, data)
}
//激活管理	activation
export function activationList(data) {
    const url = config.shopHttps.api + '/apirebate/system/getactivate'
    return service.post(url, data)
}
//活动类表-	数据统计
export function infoData(data) {
    const url = config.shopHttps.api + '/apirebate/system/rebateshopinfo'
    return service.post(url, data)
}
//激活列表-	数据统计
export function infoactiveData(data) {
    const url = config.shopHttps.api + '/apirebate/system/getactiveinfo'
    return service.post(url, data)
}